



















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Environment } from '@/interfaces/Environment';
import { Step } from '@/interfaces/Step';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { EnvironmentChangesStep } from '@/interfaces/EnvironmentChangesStep';

@Component({})
export default class WaveMatrixStarttimeInput extends Vue {
  selectedEnvironment: number | null = null;

  @Prop()
  step!: Step;

  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  environment!: Environment;

  private menu = {
    planned_startdate: false
  };

  private yyyyMmDd(value: string) {
    return (
      !value ||
      value.match(/^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/) ||
      'Falsches Format'
    );
  }

  private hhMmSs(value: string) {
    return (
      !value ||
      value.match(/^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/) ||
      'Falsches Format'
    );
  }

  set plannedStart(value: string) {
    if (!this.environment.id) {
      this.step.planned_start = value;
      return;
    }

    let stepEnvironment = this.step.environments.find(
      (sE: EnvironmentChangesStep) => sE.environment_id === this.environment.id
    );
    if (stepEnvironment) {
      stepEnvironment.change.planned_start = value;
      return;
    }

    stepEnvironment = {
      step_id: this.step.id,
      change: { planned_start: value } as Step
    } as EnvironmentChangesStep;

    this.step.environments.push(stepEnvironment);
  }

  get plannedStart(): string {
    if (!this.environment.id) {
      return this.step.planned_start || '';
    }

    const stepEnvironment = this.step.environments.find(
      (sE: EnvironmentChangesStep) => sE.environment_id === this.environment.id
    );
    if (stepEnvironment) return stepEnvironment.change.planned_start || '';
    return '';
  }

  set plannedStartdate(value: string) {
    if (!this.environment.id) {
      this.step.planned_startdate = value;
      return;
    }

    let stepEnvironment = this.step.environments.find(
      (sE: EnvironmentChangesStep) => sE.environment_id === this.environment.id
    );
    if (stepEnvironment) {
      stepEnvironment.change.planned_startdate = value;
      return;
    }

    stepEnvironment = {
      step_id: this.step.id,
      change: { planned_startdate: value } as Step
    } as EnvironmentChangesStep;

    this.step.environments.push(stepEnvironment);
  }

  get plannedStartdate(): string {
    if (!this.environment.id) {
      return this.step.planned_startdate || '';
    }

    const stepEnvironment = this.step.environments.find(
      (sE: EnvironmentChangesStep) => sE.environment_id === this.environment.id
    );
    if (stepEnvironment) return stepEnvironment.change.planned_startdate || '';
    return '';
  }
}
